/**
 * RotationButtonTile - Button that rotates all arrows 90 degrees when pressed
 */

import Phaser from "phaser";
import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";
import { GAME_CONFIG } from "../config";

export class RotationButtonTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `rotationbutton-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.ROTATION_BUTTON;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/green-button.png" };
  }

  clone(): RotationButtonTile {
    const copy = new RotationButtonTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "rotationButton", id: this.id, col: this.col, row: this.row };
  }
}
